/**
 * @generated SignedSource<<9fb31fd26239d7ad3c4a5fa7c91993c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RecordingMediaType = "AUDIO" | "VIDEO";
import { FragmentRefs } from "relay-runtime";
export type TranscriptModal_PublicClipModal_clip$data = {
  readonly clipEnd: number;
  readonly clipStart: number;
  readonly id: string;
  readonly mediaType: RecordingMediaType;
  readonly ownerAccount: {
    readonly allowRecapDownload: boolean;
    readonly logo: string;
    readonly name: string;
  };
  readonly summary: string | null;
  readonly title: string;
  readonly transcript: any | null;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_Transcript_meetingRecording" | "TranscriptVideo_meetingRecording" | "utils_useGetURL_recording">;
  readonly " $fragmentType": "TranscriptModal_PublicClipModal_clip";
};
export type TranscriptModal_PublicClipModal_clip$key = {
  readonly " $data"?: TranscriptModal_PublicClipModal_clip$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_PublicClipModal_clip">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "public",
    "value": true
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptModal_PublicClipModal_clip",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clipEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "clipStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcript",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRecapDownload",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaType",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": (v0/*: any*/),
          "kind": "FragmentSpread",
          "name": "TranscriptVideo_meetingRecording"
        },
        {
          "args": (v0/*: any*/),
          "kind": "FragmentSpread",
          "name": "TranscriptPanel_Transcript_meetingRecording"
        }
      ],
      "type": "MeetingRecordingInterface",
      "abstractKey": "__isMeetingRecordingInterface"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "utils_useGetURL_recording"
    }
  ],
  "type": "MeetingRecordingClip",
  "abstractKey": null
};
})();

(node as any).hash = "80154710e7d043ec537c40edcb6e621e";

export default node;
